// Column keys double as the backend sort keys (HorseFilters::SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer.

export function buildColumns(variant) {
  const columns = [
    { key: 'name', label: 'Horse Name', sortable: true, minWidth: '160px' },
    { key: 'owner_name', label: 'Owner', sortable: true, minWidth: '140px' },
    { key: 'zone_id', label: 'Zone', sortable: true, width: '90px' },
    { key: 'beginning_of_year_status', label: 'BoY Status', sortable: true, width: '100px' },
    { key: 'horse_status_id', label: 'Status', sortable: true, width: '90px' }
  ]

  if (variant === 'admin') {
    // Fixed, not `max-content`: each rtable__line (header, each row) is its own independent
    // CSS Grid, so a content-sized track is computed per line and drifts out of alignment —
    // the header's "Remove" label and a row's (shrunk, see .remove-btn) button aren't the
    // same width. A shared px value is what keeps every line's column edges lined up.
    columns.push({ key: 'remove', label: 'Remove', width: '80px', cellClass: 'text-left' })
  }

  return columns
}

// Below 700px the row collapses into an accordion: the horse name stays visible, the rest
// drops into the expanded detail — matching the legacy DataTable expandedHeader / expandedRow.
export function buildBreakpoints(variant) {
  const rows = [
    ['owner_name'],
    ['zone_id'],
    ['beginning_of_year_status'],
    ['horse_status_id']
  ]

  if (variant === 'admin') rows.push(['remove'])

  return [
    {
      maxWidth: 700,
      hideHeader: true,
      accordion: {
        summary: [{ keys: ['name'], hideLabel: true }]
      },
      rows
    }
  ]
}

export const REGISTRATION_TABS = [
  { value: 'all', label: 'All' },
  { value: 'registered', label: 'Registered' },
  { value: 'unregistered', label: 'Unregistered' }
]



// WEBPACK FOOTER //
// ./src/views/Horses/Listing/columns.js